import React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrophy } from '@fortawesome/free-solid-svg-icons';

import './LeaderTrophy.scss';

const TROPHIES = ['gold', 'silver', 'bronze'];

interface LeaderTrophyProps {
  /** Place on the leaderboard, from 0. */
  index: number;
  className?: string;
}

/** A gold, silver or bronze trophy for the top three on the song leaderboard, and the place number after that. */
const LeaderTrophy = ({ index, className }: LeaderTrophyProps) => {
  const trophy = TROPHIES[index];
  const classes = ['leader-trophy', trophy ? `leader-trophy-${trophy}` : '', className || ''].filter(Boolean).join(' ');
  return (
    <span className={classes} title={`Number ${index + 1}`}>
      {trophy ? <FontAwesomeIcon icon={faTrophy} /> : index + 1}
    </span>
  );
};

export default LeaderTrophy;
